import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

function MenuLink({ item, onClick }) {
  const testid = `menu-link-${item.label.toLowerCase().replace(/[^a-z0-9\u0600-\u06FF]+/g, '-')}`;
  const cls = "group flex min-h-[44px] items-start gap-3 rounded-lg px-3 py-2.5 hover:bg-[#FFF4ED] active:bg-[#FFF4ED] transition-colors";
  const body = (
    <>
      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#EE5A01] flex-shrink-0 group-hover:scale-125 transition-transform" />
      <span>
        <span className="flex items-center gap-1.5 font-heading font-semibold text-sm text-[#121212] group-hover:text-[#EE5A01] transition-colors">{item.label}{item.external && <ExternalLink className="w-3 h-3 text-[#EE5A01]" />}</span>
        {item.sub && <span className="block font-body text-xs text-[#666666] mt-0.5">{item.sub}</span>}
      </span>
    </>
  );
  if (item.external) return <a href={item.href} target="_blank" rel="noopener noreferrer" onClick={onClick} data-testid={testid} className={cls}>{body}</a>;
  return <Link to={item.href} onClick={onClick} data-testid={testid} className={cls}>{body}</Link>;
}

const PANEL = "rounded-2xl bg-white border border-black/5 shadow-[0_24px_60px_rgba(0,0,0,0.14)] overflow-hidden w-[326px] p-3";

export function NavDropdown({ dropdownId, nav, isAr, alignRight = false, onNavigate }) {
  const sections = (nav.menus && nav.menus[dropdownId]) || [];
  if (!sections.length) return null;
  const side = isAr ? (alignRight ? 'left-0' : 'right-0') : (alignRight ? 'right-0' : 'left-0');
  return (
    <div className={`absolute top-full pt-2 ${side} z-50`}>
      <div data-testid={`${dropdownId}-dropdown`} className={PANEL}>
        {sections.map((sec, i) => (
          <div key={sec.header || `sec-${i}`} className={i > 0 ? 'mt-2 pt-3 border-t border-black/5' : ''}>
            {sec.header && <span className="chip-orange mx-2 mb-2 inline-block">{sec.header}</span>}
            <div>{sec.items.map((item) => <MenuLink key={item.label} item={item} onClick={onNavigate} />)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
